import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs';
import { GoogleFontService } from '../../../services/google-font.service';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { FontWeightNamePipe } from '../../pipes/font-weight-name.pipe';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemComponent } from '../access-item/access-item.component';

@Component({
  selector: 'app-theme-font-weight-item',
  imports: [
    AccessItemComponent,
    AccessItemHeaderComponent,
    AccessItemCtaComponent,
    ContextMenuComponent,
    ButtonDirective,
    SvgComponent,
    ButtonMenuItemComponent,
    FontWeightNamePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-font-weight-item.component.html',
  styleUrl: './theme-font-weight-item.component.scss',
})
export class ThemeFontWeightItemComponent {
  private googleFontService = inject(GoogleFontService);
  fontFamily = input.required<string>();
  fontWeight = input.required<string>();
  fontWeightChange = output<string>();
  weights = toSignal(
    toObservable(this.fontFamily).pipe(switchMap(fontFamily => this.googleFontService.getFontWeights(fontFamily)))
  );
}
